import Content from "uxp-documentation/src/pages/uxp-api/reference-html/General/script";
import * as React from 'react';
export default {
  Content,
  React
};